/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneLabel from 'DesignSystem/TysiaSelectOne/TysiaSelectOneLabel/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Insurance/AddAction/Content/Content/Filter/CarrierSelect/Content",
  onChangeFilter
  
}) {
let selectedSearchTermValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'search_term',
})
let carriersValueData = fromData.useDataValue({ viewPath,
context: 'carriers',
})
let selectedFilterIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'filter_id',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let onChange = fromHelpers.useOnChange({
  children,
  viewPath,
  onChangeFilter
  
})
  return (<React.Fragment
>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 data="selected.search_term"
 placeholder="Search for carrier or employer..."
 valueFilter={selectedSearchTermValueData}
 onChangeFilter={onChangeFilter}
 data="carriers"
 from={carriersValueData}
 data="selected.filter_id"
 value={selectedFilterIdValueData}
 onChange={onChange}
 marginTop={0}
 marginRight={dtSpaceS}
 textAlign="left"
 optionsWidth={390}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneLabel`}
 text="Carrier or Employer"
/>
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
</React.Fragment>
)}
</TysiaSelectOne>
{children}
</React.Fragment>)
}